import styled from 'styled-components'

import { Colors } from '@fourthwall/components'

export const UploadContainer = styled.div`
  border: 1px dashed ${Colors.GS700};
  width: 100%;
  height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  margin-top: 40px;
  color: ${Colors.GS600};
`

export const UploadContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const Divider = styled.div`
  width: 100%;
  margin-bottom: 26px;
  text-align: center;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    height: 1px;
    right: calc(50% + 24px);
    width: 60px;
    top: 50%;
    background: ${Colors.GS500};
  }

  &:after {
    content: '';
    position: absolute;
    height: 1px;
    left: calc(50% + 24px);
    width: 60px;
    top: 50%;
    background: ${Colors.GS500};
  }
`

export const LoaderContainer = styled.div`
  padding-top: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const EmptyStateContainer = styled.div`
  border-top: 1px solid ${Colors.GS400};
  padding-top: 80px;
  padding-bottom: 80px;
`
